export default "__VITE_ASSET__DM$O9DQQ__"